var exports = {
  "kL": "x936d19a0--965f3d--container",
  "_8": "x936d19a0--965f3d--img",
  "p2": "x936d19a0--965f3d--text-info",
  "qU": "x936d19a0--965f3d--one-column",
  "Cv": "x936d19a0--965f3d--two-column",
  "kb": "x936d19a0--965f3d--left",
  "pG": "x936d19a0--965f3d--right",
  "O0": "x936d19a0--965f3d--rating",
  "uf": "x936d19a0--965f3d--stars",
  "Yq": "x936d19a0--965f3d--reviews",
  "UU": "x936d19a0--965f3d--name",
  "Pf": "x936d19a0--965f3d--label",
};

module.exports = exports;
